import React, { useEffect, useMemo, useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

import Banner, { BannerProps } from '../../../components/banner/Banner';
import { Workshop } from '../../../models/auto-generated-strapi-types/types/Workshop';
import BannerVideo, {
  BannerVideoProps,
} from '../../../components/banner-video/BannerVideo';
import { Slug } from '../../../models/domain/interfaces';

import { StyledContentWrapper } from './CardTopWorkshop.style';

interface CardTopWorkshopProps {
  workshop: {
    data: Workshop;
  };
  forceHideDescription?: boolean;
  forceHideButton?: boolean;
  forceHideBreadcrumb?: boolean;
  headerDescriptionPosition?: 'default' | 'under' | 'hidden';
  forceHideTitle?: boolean;
  forceDescriptionToBeWhite?: boolean;
  forceDescriptionToBeBlack?: boolean;
  headerCoverResize?: 'default_cover' | 'contain' | 'hidden';
  breadCrumb: {
    links: {
      href: string;
      name: string;
      disabled?: boolean;
      color?: string;
    }[];
    pageActive: {
      name: string;
      color?: string;
    };
  };
}

const CardTopWorkshop: React.FC<any> = ({
  data,
  translations,
  isPrerenderRequest,
}: {
  data: CardTopWorkshopProps;
  translations: any;
  isPrerenderRequest: boolean;
}) => {
  //card per news o evento in primo piano
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpointsMediaQuery.up('sm'));
  const [, setRerender] = useState<number>(0); // Trick to force re-render

  useEffect(() => {
    setRerender(Date.now());
  }, []);

  const image = useMemo(() => {
    if (data?.workshop?.data) {
      const { coverImage, mobileCoverImage } = data?.workshop?.data?.attributes;
      return typeof window === 'undefined' || isDesktop
        ? coverImage
        : mobileCoverImage?.data
          ? mobileCoverImage
          : coverImage;
    }
  }, [data?.workshop?.data, isDesktop]);

  const video = useMemo(() => {
    if (data?.workshop?.data) {
      const { video, mobileVideo } = data?.workshop?.data?.attributes;
      return typeof window === 'undefined' || isDesktop
        ? video
        : mobileVideo?.data
          ? mobileVideo
          : video;
    }
  }, [data?.workshop?.data, isDesktop]);

  if (data?.workshop?.data) {
    const {
      title,
      description,
      overlayColor,
      titleRegistration,
      descriptionRegistration,
      registration,
      videoAutoPlay,
      videoControls,
      videoLoop,
      videoMuted,
    } = data?.workshop?.data?.attributes;
    const {
      forceHideDescription,
      forceHideButton,
      forceHideBreadcrumb,
      headerDescriptionPosition,
      forceHideTitle,
      forceDescriptionToBeWhite,
      forceDescriptionToBeBlack,
      headerCoverResize,
    } = data;
    const link = `/${translations?.urls?.workshops}/${data?.workshop?.data?.attributes?.slug}`;

    let actualTitle = '';
    let actualDescription = '';

    if (registration) {
      actualTitle = titleRegistration ?? title ?? '';
      actualDescription = descriptionRegistration ?? description ?? '';
    } else {
      actualTitle = title ?? '';
      actualDescription = description ?? '';
    }

    let banner: BannerProps | BannerVideoProps = {
      title: actualTitle,
      description: actualDescription,
      button: {
        text: translations?.pages?.home?.workshopSlider?.goToWorkshop,
        url: link,
      },
      overlayColor,
      breadCrumb: data.breadCrumb,
      textLineLimit: false,
      forceHideDescription,
      forceHideButton,
      forceHideBreadcrumb,
      headerDescriptionPosition,
      forceHideTitle,
      forceDescriptionToBeWhite,
      forceDescriptionToBeBlack,
      headerCoverResize,
      isPrerenderRequest: isPrerenderRequest,
    };

    if (video?.data) {
      banner = {
        ...banner,
        video,
        videoAutoPlay,
        videoControls,
        videoLoop,
        videoMuted,
      };

      return (
        <StyledContentWrapper>
          <BannerVideo {...banner}></BannerVideo>
        </StyledContentWrapper>
      );
    } else {
      banner = { ...banner, image };

      return (
        <StyledContentWrapper>
          <Banner {...banner}></Banner>
        </StyledContentWrapper>
      );
    }
  } else {
    //TODO
    //Ritornare ultima notizia inserita se l'utente non inserisce nessuna news nel cms,
    //campo relazione nel cms non permette campo obbligatorio
    return <div></div>;
  }
};

export const getServerSideProps = async (
  section: any,
  translations: any,
  slugAnalyzed: Slug
) => {
  section.breadCrumb = {
    links: [
      {
        href: `/${slugAnalyzed.locale}`,
        name: translations?.urls?.home,
      },
    ],
    pageActive: {
      name: translations?.urls?.workshops,
    },
  };
};

export default CardTopWorkshop;
